module.exports = "/images/fizmix-logo.svg?34471cc875f807171c32ec0c16046691";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/images/fizmix-logo.svg
// module id = 2w+0
// module chunks = 0